export default "__VITE_ASSET__27673bb9__"